<template>
  <div class="position-relative d-flex mb-3" :class="{'px-4': withPadding}">
    <transition name="fade-height">
      <div v-if="!withoutAvatar && !isWaiting"
           :class="[$style.avatar, shouldHideAvatar && $style.transparent]"
           class="rounded-circle mr-2">
        <img src="../assets/zeca-icon-simple.svg" class="w-100 h-auto" alt="Amy">
      </div>
    </transition>

    <transition name="fade-height" appear>
      <Typing :class="$style.typing" v-if="isTyping"/>
    </transition>

    <transition name="fade-height">
      <div v-if="shouldRenderMessage && isReadyToRender"
           :class="{ 'ml-auto': owner === 'user', 'flex-fill': type !== 'text' }">
        <component :is="messageType" v-bind="message"/>
      </div>
    </transition>
  </div>
</template>

<script>
  import Typing from 'components/Typing';
  import TextMessage from 'components/message_types/Text';
  import CardMessage from 'components/message_types/Card';
  import CarouselMessage from 'components/message_types/Carousel';
  import ListMessage from 'components/message_types/List';
  import MediaMessage from 'components/message_types/Media';
  import {mapActions} from 'vuex';
  import {camelCaseToDash} from 'lib/utils';
  import { getQueryStringParams } from '../lib/utils';

  export default {
    name: 'Message',
    components: {
      Typing,
      TextMessage,
      CardMessage,
      CarouselMessage,
      ListMessage,
      MediaMessage
    },
    props: {
      owner: {
        type: String,
        required: true,
        validator(value) {
          return ['bot', 'user'].indexOf(value) > -1;
        }
      },
      type: {
        type: String,
        required: true
      },
      message: {
        type: Object,
        required: true
      }
    },
    data() {
      const {typing} = this.message;
      const {type, owner} = this;

      return {
        isWaiting: !!(typing && typing.wait),
        isTyping: false,
        isReady: false,
        isReadyToRender: false,
        shouldRenderMessage: type !== 'quickReplies' && type !== 'empty',
        shouldHideAvatar: type === 'card',
        withPadding: type !== 'carousel',
        messageType: camelCaseToDash(type) + '-message',
        withoutAvatar:
          owner !== 'bot' ||
          type === 'carousel' ||
          type === 'list' ||
          type === 'media' ||
          type === 'quickReplies'
      }
    },
    mounted() {
      const {typing} = this.message;
      if (!typing) {
        this.isReadyToRender = true;
        this.setReady();
        return;
      }

      const {wait, duration} = typing;

      if (wait)
        this.startWaiting();
      else if (duration)
        this.startTyping();
    },
    methods: {
      ...mapActions(['toggleQuickReplies']),
      setReady() {
        if (this.isReady) return;
        this.isReady = true;

        if (this.message.type === 'quickReplies')
          this.toggleQuickReplies(this.message.items);
      },
      startWaiting() {
        const {typing: {wait, duration}} = this.message;
        this.isWaiting = true;

        setTimeout(() => {
          this.isWaiting = false;

          if (duration)
            this.startTyping();
          else {
            this.isReadyToRender = true;
            this.setReady();
          }
        }, wait);
      },
      startTyping() {
        this.setReady();
        const {typing: {duration}} = this.message;
        this.isTyping = true;
        setTimeout(() => {
          this.isTyping = false;
          this.isReadyToRender = true;
        }, duration);
      }
    }
  };
</script>

<style lang="scss" module>
  .avatar {
    min-width: 32px;
    width: 32px;
    min-height: 32px;
    height: 32px;
  }

  .transparent {
    opacity: 0;
  }

  .typing {
    position: absolute;
    left: 65px;
    top: 8px;
  }
</style>
